
import React, { useEffect, useState, useContext } from 'react';
import MyContext from '../../../context/MyContext'

const LockedText = ({ index, value }) => {
  var FontFaceObserver = require('fontfaceobserver');
  const [FontAvailable, setFontAvailable] = useState(false)
  const { LayersData, setLayersData } = useContext(MyContext)
  function isHTML(str) {
    var a = document.createElement('div');
    a.innerHTML = str;

    for (var c = a.childNodes, i = c.length; i--;) {
      if (c[i].nodeType == 1 && c[i].tagName.toLowerCase() != 'br') return true;
    }

    return false;
  }
  useEffect(() => {
    if (isHTML(value.text)) {

      const array = Array.from(LayersData);
      for (var i = 0; i < array.length; i++) {
        if (array[i].key === value.key) {
          var a = document.createElement('div');
          a.innerHTML = value.text;
          array[i].text = a.firstChild.innerHTML;
        }
      }
      setLayersData(array);
    }
  }, [value.text])
  // useEffect(() => {
  //   var link = document.createElement("link")
  //   link.setAttribute("rel", "stylesheet")
  //   link.setAttribute("type", "text/css")
  //   link.setAttribute("href", value.googleFontSetting.googleFontUrl)
  //   document.getElementsByTagName("head")[0].appendChild(link);
  //   var font = new FontFaceObserver(value.googleFontSetting.fontName);
  //   font.load().then(function () {
  //     setFontAvailable(true);
  //   },
  //     function () {
  //       setFontAvailable(false)
  //     });
  // }, [value.googleFontSetting])
  return (<> {
     <span editing="true" id={"Text-" + value.AnimationId} key={index} className="textInput" spellCheck="false"
      style={{
        opacity: value.opacity, textDecoration: value.textDec, fontStyle: value.Fontstyle, fontSize: value.fontSize,
        fontWeight: value.fontWeight, color: value.textColor, maxWidth: value.width,
        fontFamily: value.googleFontSetting.fontName, overflowWrap: 'break-word',
      }}
      dangerouslySetInnerHTML={{ __html: value.text }}
    >
    </span>
  } </>);
};


export default LockedText;